import { P2GBox, P2GFade, P2GGrid } from '@parcel2go/core-ui';
import { useCallback, useState } from 'react';
import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import Loading from '../../../../../components/loading/Loading';
import { P2GSticky } from '@parcel2go/core-ui';
import { PanelButtons } from './PanelButtons';
import { useP2GMediaQueryOnly } from '@parcel2go/core-ui';
import { RestoreItemRow } from './RestoreItemRow';
import { P2GImageMessage } from '~/components/imagemessage';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';
import useOnLoad from '~/routes/use-on-load';

interface props {
  close: () => void;
  items: () => Promise<SmartSendItemApiModel[]>;
  onRestore: (ids: string[]) => void;
}

export const RestorePanel: React.FC<props> = (props) => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [items, setItems] = useState<SmartSendItemApiModel[]>([]);
  const [selected, setSelected] = useState<string[]>([]);
  const isXs = useP2GMediaQueryOnly('xs');
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);

  useOnLoad(() => {
    const load = async () => {
      const items = await props.items();
      setItems(
        items
          .map((x) => ({ ...x, Created: new Date(x.Created) }))
          .sort((a, b) => b.Created.getTime() - a.Created.getTime())
      );
      setLoading(false);
    };
    load();
  });

  const toggle = useCallback(
    (x: SmartSendItemApiModel) =>
      setSelected((xx) => (xx.includes(x.Id) ? xx.filter((s) => s != x.Id) : [...xx, x.Id])),
    []
  );

  if (loading || saving) {
    return <Loading />;
  }

  return (
    <P2GBox textAlign="center">
      {items.length === 0 ? (
        <P2GImageMessage
          image="/theme/common/notifications/no-results.png"
          contentKey="image-smartsend-restore-items-empty-list"
        />
      ) : (
        <P2GGrid container direction="column" gap={2}>
          {items.map((x, i) => (
            <P2GGrid item key={x.Id}>
              <P2GFade in timeout={i * 150}>
                <RestoreItemRow item={x} selected={selected.includes(x.Id)} toggle={() => toggle(x)} isXs={isXs} />
              </P2GFade>
            </P2GGrid>
          ))}
        </P2GGrid>
      )}
      <P2GSticky align="bottom">
        <P2GBox pt={2} pb={2}>
          <PanelButtons
            saveText={t('RESTORE_BUTTON', { defaultValue: 'Restore' })}
            onSave={() => {
              setSaving(true);
              props.onRestore(selected);
            }}
            saveDisabled={items.length === 0 || selected.length === 0}
            onCancel={props.close}
          />
        </P2GBox>
      </P2GSticky>
    </P2GBox>
  );
};
